import { transformToApiError as e } from "@frontends/util-api-errors";
import t from "axios";
//#region src/lib/http.ts
var n = t.create({ baseURL: "/api/v1" });
n.interceptors.response.use(void 0, (t) => Promise.reject(e(t)));
//#endregion
//#region src/lib/listPage.ts
function r(e, t) {
	return typeof e == "number" && typeof t == "number" ? e - t : String(e).localeCompare(String(t));
}
function i(e, t, n) {
	let i = t.sortOrder === "asc" ? 1 : -1;
	return {
		data: [...e].sort((e, a) => r(n(e, t.sortBy), n(a, t.sortBy)) * i).slice(t.offset, t.offset + t.limit),
		total: e.length
	};
}
//#endregion
//#region src/lib/querykit.ts
function a(e, t = []) {
	let n = {
		[`sort[${e.sortBy}]`]: e.sortOrder,
		limit: e.limit,
		offset: e.offset
	};
	for (let { field: e, op: r, value: i } of t) n[`filter[${e}][${r}]`] = Array.isArray(i) ? i.join(",") : i;
	return n;
}
//#endregion
export { n as http, i as toListPage, a as toQueryParams };
